module.exports = __webpack_public_path__ + "img/calendar.f70b0526.svg";